import { cn } from '@/lib/utils';

import Card from '../Card';
import { Text, TextProps } from '../Text';

export interface CountdownTimerProps {
  label?: string;
  timeComponents: {
    days: string;
    mins: string;
    hours: string;
    secs: string;
  };
  isTimerVisible?: boolean;
  classNames?: {
    root?: string;
    text?: string;
  };
}

const mutualTextProps: Partial<TextProps> = {
  variant: 'body-l',
};

export const CountdownTimer = ({
  label,
  timeComponents,
  isTimerVisible = true,
  classNames,
}: CountdownTimerProps) => {
  const combinedTextProps = {
    ...mutualTextProps,
    classNames: { wrapper: classNames?.text },
  };

  return (
    <div className='flex flex-row gap-2'>
      {!!label && (
        <span>
          {label}
          {isTimerVisible && <span> -</span>}
        </span>
      )}
      {isTimerVisible && (
        <Card
          data-hidden='false'
          classNames={{
            root: cn(
              'dark:bg-brand-600 bg-brand-600 flex flex-row border-none gap-2 py-1 px-3 dark font-mono',
              classNames?.root
            ),
          }}
        >
          <Text {...combinedTextProps}> {timeComponents.days} d</Text>
          <Text {...combinedTextProps}>:</Text>
          <Text {...combinedTextProps}> {timeComponents.hours} h</Text>
          <Text {...combinedTextProps}>:</Text>
          <Text {...combinedTextProps}> {timeComponents.mins} m</Text>
          <Text {...combinedTextProps}>:</Text>
          <Text {...combinedTextProps}> {timeComponents.secs} s</Text>
        </Card>
      )}
    </div>
  );
};
